var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSideBarMenuDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "6shacsdaua"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.275000 0 0 0 0 0.327941 0 0 0 0 0.500000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16 -11)",
    filter: "url(#6shacsdaua)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.5 17.5)",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 6,
    height: 7,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 0.5,
    width: 6,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 9.5,
    width: 6,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 7.5,
    width: 6,
    height: 7,
    rx: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSideBarMenuDashboard);
export default __webpack_public_path__ + "static/media/ico-side-bar-menu-dashboard.4d3432b86929248e7d1aed2c15c74b48.svg";
export { ForwardRef as ReactComponent };